import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ReportVerificationComponent } from './report-verification.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [ReportVerificationComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    InputTextModule,
    SharedModule,
  ],
  exports: [ReportVerificationComponent],
})
export class ReportVerificationModule {}
